import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { EmptyState } from "@/components/EmptyState";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { fmtDate } from "@/lib/format";
import { getErrorMessage } from "@/lib/errors";

export default function AuditLog() {
  const [docType, setDocType] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/audit-log", { params: { doc_type: docType || undefined } });
      setRows(data);
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="audit-log-page">
      <PageHeader
        title="Global Audit Log"
        description="Who did what, to which ERP document, and when — postings, approvals and unlocks."
        action={
          <div className="flex gap-2">
            <Input placeholder="Filter by doc type e.g. JOURNAL_ENTRY" value={docType} onChange={(e) => setDocType(e.target.value)} className="w-64" data-testid="audit-log-doc-type-filter" />
            <Button onClick={load} data-testid="audit-log-filter-button">Filter</Button>
          </div>
        }
      />
      <div className="rounded-xl border border-border bg-card">
        {!loading && rows.length === 0 ? (
          <EmptyState title="No audit entries yet" testId="audit-log-empty-state" />
        ) : (
          <Table>
            <TableHeader><TableRow><TableHead>When</TableHead><TableHead>User</TableHead><TableHead>Doc Type</TableHead><TableHead>Action</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} data-testid={`audit-log-row-${r.id}`}>
                  <TableCell className="font-mono text-xs text-muted-foreground">{fmtDate(r.created_at)}</TableCell>
                  <TableCell className="text-xs text-foreground">{r.user_email || "system"}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{r.doc_type}</TableCell>
                  <TableCell><Badge variant="secondary">{r.action}</Badge></TableCell>
                  <TableCell className="max-w-md truncate text-xs text-muted-foreground">{r.new_value ? JSON.stringify(r.new_value) : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
